import React from "react";
import MRadio from "@mui/material/Radio";

const Radio = (props) => {
    return <MRadio {...props} />
}

export default Radio;